import FullCalendar from '@fullcalendar/react';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
  Box,
  Button,
  ButtonGroup,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';

export default function CalendarHeader({
  onAddEvent,
  calendarRef,
}: {
  onAddEvent: () => void;
  calendarRef: React.RefObject<FullCalendar>;
}) {
  const view = calendarRef.current?.getApi().view;
  const [activeView, setActiveView] = useState('timeGridWeek');
  const handleChangeView = (viewName: string) => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();

      calendarApi.changeView(viewName);
      setActiveView(viewName);
    }
  };

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 3,
        py: 2,
      }}
    >
      <Stack direction='row' alignItems='center' spacing={3}>
        <Box
          sx={{
            width: 210,
          }}
        >
          <Typography variant='h6' sx={{ fontWeight: 500, minWidth: 155 }}>
            {view?.title}
          </Typography>
        </Box>
        <Button
          variant='outlined'
          onClick={() => {
            if (calendarRef.current) {
              calendarRef.current.getApi().today();
            }
          }}
          color='inherit'
          sx={{
            borderRadius: 0,
          }}
        >
          Today
        </Button>
        <ButtonGroup>
          <IconButton
            onClick={() => {
              if (calendarRef.current) {
                calendarRef.current.getApi().prev();
              }
            }}
          >
            <KeyboardArrowLeftIcon />
          </IconButton>

          <IconButton
            onClick={() => {
              if (calendarRef.current) {
                calendarRef.current.getApi().next();
              }
            }}
          >
            <KeyboardArrowRightIcon />
          </IconButton>
        </ButtonGroup>
      </Stack>
      <Stack direction='row' alignItems='center' spacing={2}>
        <Select
          value={activeView}
          onChange={(e: SelectChangeEvent) => handleChangeView(e.target.value)}
          sx={{
            maxHeight: 40,
            width: 140,
            borderRadius: 0,
          }}
        >
          <MenuItem value='dayGridMonth'>Month</MenuItem>
          <MenuItem value='timeGridWeek'>Weekly</MenuItem>
          <MenuItem value='timeGridDay'>Daily</MenuItem>
        </Select>
        <Button
          disableElevation
          variant='contained'
          startIcon={<AddIcon />}
          onClick={onAddEvent}
          sx={{
            height: 40,
            width: 140,
            borderRadius: 0,
          }}
        >
          Add Event
        </Button>
      </Stack>
    </Stack>
  );
}
